<template>
    <v-expansion-panel>
      <!-- loading overlay -->
      <block v-if="loading"></block>
        <v-expansion-panel-header>
            Conexión
            <template v-slot:actions>
                <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
                    <v-icon color="error">mdi-close</v-icon>
                </v-btn>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-card>
                <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
                    <v-tabs-slider color="red"></v-tabs-slider>

                    <v-tab href="#tab-1">
                        Opciones de conexión 
                        <v-icon>mdi-transit-connection-variant</v-icon>
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <v-tab-item value="tab-1">
                    <div class="pa-1">
                      <v-card flat>
                        <v-card-text class=" white">
                          <h2 class="py-3">Activar conexión de respaldo</h2>
                          <p class="py-3" style="font-size: 1.25rem">Esta opción solamente se debe activar en casos de emergencia, cuando el contact center de InnovaB lo indique.</p>
                          <div class="d-flex justify-left align-center">
                            <Button
                              prepend-icon="mdi-transit-connection-variant"
                              @click="searchConnection"
                            >
                              Buscar conexión
                            </Button>
                            <Button
                              class="ml-4"
                              prepend-icon="mdi-update"
                              @click="updateCatalogs"
                            >
                              Actualizar Catálogos
                            </Button>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-expansion-panel-content>

        <!-- alert component -->
        <alert
          v-model="alert.show"
          :type="alert.type"
          :title="alert.title"
          :message="alert.message"
          btn-cancel-text="Aceptar"
        ></alert>
    </v-expansion-panel>
</template>

<script>
import Button from '@/components/Button';
import axios from '@/api/axios'

export default {
  name: "ConnectionSettings",
  components: {
    Button,
  },
  props: ['win'],
  data() {
    return {
      tab: 0,
      loading: false,
      alert: {
        show: false,
        type: "info",
        title: "",
        message: "",
      },
    }
  },
  methods: {
    async searchConnection () {
      this.loading = true;
      try {
        console.log('search connection')

        const res = await axios.updateBackendUrl()

        console.log('update res')
        console.log(res)

        if (res.notChanged) {
          this.showAlert(
            "Alerta",
            "Alerta",
            "No han ocurrido cambios en la conexión."
          );
        } else if (res.pingFailed) {
          this.showAlert(
            "Alerta",
            "Error",
            "No se pudo establecer la conexión recomendada."
          );
        } else {
          if (res.isBackup) {
            this.showAlert(
              "Alerta",
              "Error",
              "Se estableció una conexión de respaldo."
            );
          } else {
            this.showAlert(
              "Alerta",
              "Error",
              "Se ha establecido una conexión estable."
            );
          }
        }
      } catch (err) {
        console.log(err)
        this.showAlert(
          "Error",
          "Error",
          "Error buscando conexión."
        );
      }
      
      this.loading = false;
    },
    async updateCatalogs(){
      this.loading = true;
      try {
        this.$store.commit('setCatalogMH', null);
        await this.$store.dispatch("getCatalogMH");
        this.alert.show = true;
        this.alert.type = 'success'; 
        this.alert.title = 'Éxito';
        this.alert.message = 'Catálogos actualizados correctamente.';
      } catch (error) {
        this.alert.show = true;
        this.alert.type = 'error'; 
        this.alert.title = 'Error';
        this.alert.message = 'Error actualizando catálogos. Intentelo de nuevo mas tarde.';
      } finally {
        this.loading = false;
      }
    },
    showAlert(type, title, message) {
      this.alert.type = type;
      this.alert.title = title;
      this.alert.message = message;
      this.alert.show = true;
    },
  },
}
</script>

<style scoped>
    .v-input__control {
        background: white !important;
    }

</style>
